export default function setTextAccLongDescriptionAction(longDescription) {
    return {
        type: 'SET_LONG_DESCRIPTION',
        payload: longDescription
    }
}